import { render, staticRenderFns } from "./AppShopNavigation.vue?vue&type=template&id=5bec48e1&scoped=true"
import script from "./AppShopNavigation.vue?vue&type=script&lang=ts"
export * from "./AppShopNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bec48e1",
  null
  
)

export default component.exports